const initialState = {
  headerTable: [],
  irrigacionSemanal: [],
  propiedadesRegistros: [],

  semanaIrrigacion: null,
  fecha: undefined,

  periodos: [],

  irrigaciones: [],
  valvulaID: null,
  periodoID: null,

  parametrosIrrigacion: {},
};

export const actionTypes = Object.freeze({
  SET_INITIAL_DATA: 'riego/SET_INITIAL_DATA',
  SET_SEMANA: 'riego/SET_SEMANA',
  SET_FECHA: 'riego/SET_FECHA',
  SET_PERIODOS: 'riego/SET_PERIODOS',
  SET_IRRIGACIONES: 'riego/SET_IRRIGACIONES',
  SET_IRRIGACION_A_FILTRAR: 'riego/SET_IRRIGACION_A_FILTRAR',
  FILTRAR_POR_VALVULA: 'riego/FILTRAR_POR_VALVULA',
  FILTRAR_POR_PERIODO: 'riego/FILTRAR_POR_PERIODO',
  RESTABLECER_FILTROS: 'riego/RESTABLECER_FILTROS',
});

export function createInitialState({ semana }) {
  return {
    ...initialState,
    semanaIrrigacion: semana,
  }
};

export function riegoReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_INITIAL_DATA: {
      return {
        ...state,
        valvulaID: null,
        periodoID: null,
        headerTable: action.headerTable,
        irrigacionSemanal: action.irrigacionSemanal,
        propiedadesRegistros: action.propiedadesRegistros,
      };
    }
    case actionTypes.SET_SEMANA: {
      return {
        ...state,
        semanaIrrigacion: action.semana,
        fecha: null,
      };
    }
    case actionTypes.SET_FECHA: {
      return {
        ...state,
        fecha: action.fecha,
      };
    }
    case actionTypes.SET_PERIODOS: {
      return {
        ...state,
        periodos: action.periodos,
      };
    }
    case actionTypes.SET_IRRIGACIONES: {
      return {
        ...state,
        valvulaID: null,
        periodoID: null,
        irrigaciones: action.irrigaciones
      };
    }
    case actionTypes.SET_IRRIGACION_A_FILTRAR: {
      return {
        ...state,
        parametrosIrrigacion: {
          data: action.parametros,
          agrupador: action.agrupador,
        }
      };
    }
    case actionTypes.FILTRAR_POR_VALVULA: {
      return {
        ...state,
        valvulaID: action.valvulaID,
        periodos: action.periodos,
      };
    }
    case actionTypes.FILTRAR_POR_PERIODO: {
      return {
        ...state,
        periodoID: action.periodoID,
        periodos: action.periodos,
      };
    }
    case actionTypes.RESTABLECER_FILTROS: {
      return {
        ...state,
        valvulaID: null,
        periodoID: null,
      };
    }
    default:
      return state
  }
};